import React from 'react'

import CheckBox from 'apps/consent-app/main-form/MainFormCheckBox'

const MainFormCheckBox = ({label, t, ...props}) => (
  <CheckBox {...props} label={<span>{`${t('checkboxes.marketing')} ${t('optional')}`}</span>} />
)

export default MainFormCheckBox
